import { splitCsv } from "~/pages/Directory/shared/filterHelpers";

const PARTNER_FILTER_VALUE_PATTERN =
  /^partner:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}:([A-Za-z0-9_-]*)$/i;

const encodePartnerFilterLabel = (label: string) =>
  Buffer.from(label, "utf-8")
    .toString("base64")
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");

const decodePartnerFilterLabel = (label: string) =>
  Buffer.from(label.replace(/-/g, "+").replace(/_/g, "/"), "base64").toString(
    "utf-8",
  );

export const createPartnerFilterValue = (id: string, label: string) =>
  `partner:${id}:${encodePartnerFilterLabel(label)}`;

export const getPartnerFilterValueLabel = (value: string) => {
  const match = value.match(PARTNER_FILTER_VALUE_PATTERN);

  if (!match) {
    return value;
  }

  try {
    return decodePartnerFilterLabel(match[1]);
  } catch {
    return value;
  }
};

export interface ILicensesUrlParams {
  page?: string;
  count?: string;
  sortField?: string;
  sortType?: string;
  filterBy?: string;
  filterValues?: string;
  inn?: string;
  branchCode?: string;
  licenseType?: string;
  overallState?: string;
  openModal?: string;
}

export interface ILicensesFilter {
  filterBy: string;
  filterValues: string[];
  inn: string;
  branchCode: string;
  licenseType: string;
  overallState: string;
}

export const parseLicensesFilterFromUrl = (
  params: ILicensesUrlParams,
): ILicensesFilter => ({
  filterBy: params.filterBy || "",
  filterValues: splitCsv(params.filterValues),
  inn: params.inn || "",
  branchCode: params.branchCode || "",
  licenseType: params.licenseType || "all",
  overallState: params.overallState || "all",
});
